module.exports = __webpack_public_path__ + "static/media/aiden.e012951e.png";